<app-hero
	[title]="'hero.live' | translate"
	imageDesktop="assets/hero/live-hero-3840x400.jpg"
	imageMobile="assets/hero/live-hero-768x180.jpg"
/>
<div class="container-xxl mh-500 mt-3">
	<div class="stickyTop-l1 bg-lightgray gray-shadow py-2 py-lg-3">
		<aside>
			<clock [timeOffset]="timeOffset" />

			@if (!(observedAuctions?.length || leasysObservedAuctions?.length)) {
				<div class="mt-4">
					<a
						routerLink="/private"
						class="text-uppercase text-basecolor"
					>
						<span class="simple-arrow simple-arrow-left d-inline-block align-middle"></span>
						<span>{{ "auction.details.allAuctions" | translate }}</span></a
					>
				</div>
			}
		</aside>
	</div>

	@if (leasysObservedAuctions && observedAuctions) {
		<!-- they are initialized together -->
		@for (ob of leasysObservedAuctions; track ob.auctionDTO.idAuction) {
			<div class="mt-3">
				<app-live-item
					[observedAuctionDTO]="ob"
					[reconnectEmitter]="reconnectEmitter"
					(trimAuction)="trimAuction(leasysObservedAuctions, ob)"
					[timeOffset]="timeOffset"
				/>
			</div>
		}
		@for (ob of observedAuctions; track ob.auctionDTO.idAuction) {
			<div class="mt-3">
				<app-live-item
					[observedAuctionDTO]="ob"
					[reconnectEmitter]="reconnectEmitter"
					(trimAuction)="trimAuction(observedAuctions, ob)"
					[timeOffset]="timeOffset"
				/>
			</div>
		}
		@if (leasysObservedAuctions.length + observedAuctions.length === 0) {
			<div class="py-5 text-center">
				<span class="text-blue text-xl"> {{ "auction.live.noObservedFound" | translate }}</span>
			</div>
		}
		@if (notAllBlind) {
			<auction-legend />
		}
	} @else {
		<div class="pt-5 text-center">
			<span class="text-blue text-xl"> {{ "auction.live.retrievingObserved" | translate }}</span>
		</div>
	}
</div>

<ng-template #connectError>
	<div class="p-4">
		<button
			type="button"
			class="close-x position-absolute top-0 end-0 mt-3 me-3"
			(click)="closeTemplateModal()"
		></button>
		<p class="pt-3">
			<span class="text-big text-blue">{{ "auction.live.mqttError" | translate }}</span>
		</p>
	</div>
</ng-template>